import { Icon } from '@material-ui/core';
import React from 'react';

const CBXIcon = ({
	className,
	children,
	style,
	onClick
}) => (
	<Icon className={className} style={style} onClick={onClick}>
		{children}
	</Icon>
);

export default CBXIcon;
